// Updated src/services/stripeService.js with cancel functionality

import api from './api';

class StripeService {
  async createCheckoutSession(planSlug, billingCycle = 'monthly') {
    try {
      const response = await api.post('/auth/stripe/create-checkout-session', {
        plan_slug: planSlug,
        billing_cycle: billingCycle
      });
      
      return response.data;
    } catch (error) {
      console.error('Failed to create checkout session:', error);
      throw error;
    }
  }

  async redirectToCheckout(planSlug, billingCycle = 'monthly') {
    try {
      // Create checkout session and get the URL
      const { session_url } = await this.createCheckoutSession(planSlug, billingCycle);
      
      // Direct redirect to Stripe checkout URL
      window.location.href = session_url;
      
    } catch (error) {
      console.error('Failed to redirect to checkout:', error);
      throw error;
    }
  }

  async createPortalSession() {
    try {
      const response = await api.post('/auth/stripe/create-portal-session');
      return response.data;
    } catch (error) {
      console.error('Failed to create portal session:', error);
      throw error;
    }
  }

  async redirectToPortal() {
    try {
      const { portal_url } = await this.createPortalSession();
      window.location.href = portal_url;
    } catch (error) {
      console.error('Failed to redirect to portal:', error);
      throw error;
    }
  }

  // NEW: Cancel subscription at period end
  async cancelSubscription() {
    try {
      const response = await api.post('/auth/stripe/cancel-subscription');
      return response.data;
    } catch (error) {
      console.error('Failed to cancel subscription:', error);
      throw error;
    }
  }

  // NEW: Reactivate cancelled subscription
  async reactivateSubscription() {
    try {
      const response = await api.post('/auth/stripe/reactivate-subscription');
      return response.data;
    } catch (error) {
      console.error('Failed to reactivate subscription:', error);
      throw error;
    }
  }

  // Handle successful payment return
  handlePaymentSuccess(sessionId) {
    console.log('Payment successful for session:', sessionId);
    // Reload user data or redirect to dashboard
    return true;
  }
}

const stripeService = new StripeService();
export default stripeService;